import IAddressFlags from "@/module/main/dto/customer/IAddressFlags";
import AddressFlag from "@/module/main/dto/customer/AddressFlagEnum";
import Address from "@/module/main/dto/customer/Address";

export default class AddressFlags extends Address implements IAddressFlags {
    constructor(
        public streetAddress?: string,
        public streetNumber?: string,
        public city?: string,
        public zip?: string,
        public country?: string,
        public flags?: AddressFlag[]
    ) {
        super(streetAddress, streetNumber, city, zip, country);
    }
}
